import { Box, Button, IconButton, Popover, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ALPHABETS, Icons, latexDelimiters } from '../../../utils/utilities'
import { useMeetingStore } from '../../../store/meeting.store'
import { useSocketsContext } from '../../../contexts/sockets.context'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react'
import Latex from 'react-latex-next'
import { useOnlineSessionsSocketStore } from '../../../store/onlinesessionsocket.store'

const VotePoll = observer( ( { open, poll, setPoll } ) => {

    const [selection, setSelection] = useState( null )
    const [remainingTime, setRemainingTime] = useState( 0 )

    const { border, palette, shadows } = useTheme()
    const { meeting_id } = useParams()

    // const { socket, emitEvent } = useSocketsContext()

    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()
    const MeetingStore = useMeetingStore()

    const minimizePoll = () => {
        MeetingStore.setMeetingRoomLayoutSettings( { isPollDialogMinimized: true } )
    }

    const nextPoll = () => {
        const curr = MeetingStore.getMeetingState.currentPollIndex
        if ( curr + 1 > MeetingStore.getPolls.length - 1 )
            return MeetingStore.setMeetingState( { currentPollIndex: 0 } )
        MeetingStore.setMeetingState( { currentPollIndex: curr + 1 } )
    }

    const prevPoll = () => {
        const curr = MeetingStore.getMeetingState.currentPollIndex
        if ( curr - 1 < 0 )
            return MeetingStore.setMeetingState( { currentPollIndex: MeetingStore.getPolls.length - 1 } )
        MeetingStore.setMeetingState( { currentPollIndex: curr - 1 } )
    }

    const togglePollSelection = ( index ) => {
        if ( selection === index ) {
            setSelection( null )
        } else {
            setSelection( index )
        }
    }

    const submitPoll = async () => {
        try {
            if ( !selection && selection !== 0 ) return

            const { success, message, closePollDialog } = await OnlineSessionSocketStore.emit( 'poll:vote', { pollVote: selection, room_id: meeting_id, poll_id: poll.id } )

            console.log( success, closePollDialog, message )

            if ( success || closePollDialog ) {
                MeetingStore.addOrRemovePoll( poll, "remove" )
                MeetingStore.setMeetingRoomLayoutSettings( { isPollDialogMinimized: false } )
                setSelection( null )
            }
            if ( message )
                toast( message )
        } catch ( err ) {
            console.log( err )

        }
    }

    useEffect( () => {
        if ( !poll ) return

        const timeLeft = Math.floor( ( new Date( poll.ends_at ) - Date.now() ) / 1000 )

        const remaining = ( timeLeft / poll.duration ) * 100

        setRemainingTime( Math.max( 0, Math.min( remaining, 100 ) ) )

        const interval = setInterval( () => {
            const timeLeft = Math.floor( ( new Date( poll.ends_at ) - Date.now() ) / 1000 )

            const remaining = ( timeLeft / poll.duration ) * 100

            setRemainingTime( Math.min( remaining, 100 ) )

            if ( timeLeft <= 0 ) {
                MeetingStore.addOrRemovePoll( poll, "remove" )
                clearInterval( interval )
                setRemainingTime( 0 )
            }
        }, 2000 )

        return () => clearInterval( interval )
    }, [poll, MeetingStore] )


    return (
        <Popover disableAutoFocus disableEnforceFocus disableRestoreFocus sx={{ pointerEvents: "none", zIndex: 3001 }} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} anchorReference='anchorPosition' anchorPosition={{ top: 0, left: window.innerWidth }} slotProps={{ paper: { elevation: 5, sx: { pointerEvents: "all", width: "80%", maxWidth: "300px", bgcolor: palette.contentBg, border: `1px solid ${palette.text.disabled}` } } }} open={open} >
            <Box position="relative">
                {Boolean( remainingTime ) && <Box sx={{ transition: "200ms linear" }} position="absolute" borderRadius="10px 10px 0 0" height="5px" left="0" top="0" width={`${remainingTime}%`} bgcolor={palette.primary.main} >
                </Box>}
                <Box padding="20px">
                    <Box display="flex" gap="20px" justifyContent="space-between" alignItems="center">
                        <Box>
                            <Typography component="h1" variant='h6' margin="0" fontSize="14px">Poll {MeetingStore.getMeetingState.currentPollIndex + 1}</Typography>
                            <Typography fontSize="12px" color='textSecondary' component="em">Pending: {MeetingStore.getPolls.length}</Typography>
                        </Box>
                        <Box>
                            <Tooltip title={"Previous"} disableInteractive placement='bottom' >
                                <IconButton size='small' onClick={prevPoll} >
                                    {Icons.default.ChevronLeftIcon}
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={"Next"} disableInteractive placement='bottom' >
                                <IconButton size='small' onClick={nextPoll} >
                                    {Icons.default.ChevronRightIcon}
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={"Minimize"} disableInteractive placement='bottom' >
                                <IconButton size='small' onClick={minimizePoll} >
                                    {Icons.default.RemoveIcon}
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Box marginTop="20px">
                        <Typography fontSize="16px" fontWeight="600" component="div" ><Latex delimiters={latexDelimiters}>{poll?.question}</Latex></Typography>
                        <Box marginTop="10px">
                            {poll?.options?.map( ( option, i ) => (
                                <Box onClick={() => togglePollSelection( i )} sx={{
                                    cursor: "pointer",
                                    borderColor: selection === i ? palette.primary.main : "",
                                    ":hover": {
                                        borderColor: selection !== i ? palette.common.font : palette.primary.main,
                                        boxShadow: shadows[1]
                                    }
                                }} marginBottom='5px' border={border[1]} display="flex" borderRadius="5px" overflow="clip" bgcolor={palette.form.inputBg} alignItems="stretch" key={i}>
                                    <Box flexShrink={0} width="40px" display="flex" alignItems="center" justifyContent="center" borderRight={selection === i ? "none" : border[1]} bgcolor={selection === i ? palette.primary.light : palette.contentBgDark}>
                                        <Typography fontSize="14px" display="inline" >{ALPHABETS.at( i )}</Typography>
                                    </Box>
                                    <Typography sx={{
                                        bgcolor: selection === i ? palette.primary.main : "",
                                        color: selection === i ? palette.primary.contrastText : "",
                                    }} padding="10px" component="div" width="100%" position="relative" zIndex={2} display="block" variant='subtitle2'>
                                        <Latex delimiters={latexDelimiters}>{option}</Latex>
                                    </Typography>
                                </Box>
                            ) )}
                        </Box>
                    </Box>
                    <Box marginTop="20px" display="flex" justifyContent="flex-end" gap="10px" >
                        <Button onClick={submitPoll} sx={{ borderRadius: "20px" }} variant='contained' color='primary'>Submit</Button>
                    </Box>
                </Box>
            </Box>
        </Popover >
    )
} )

export default VotePoll
